// Lib
import * as _ from 'lodash';
import { put, call, takeLatest, debounce } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMKeywordsAPI, getLMKeywordsAPIError, getLMKeywordsAPISuccess, ActionPostLMKeywordsAPI, postLMKeywordsAPIError, postLMKeywordsAPISuccess } from './actions';
import { LMkeywords } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMkeywords } from './utils';

function* getDealerLMkeywords(action: ActionGetLMKeywordsAPI) {
  try {
    const { listingId } = action;
    const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/keywords`);
    const lmkeywords: LMkeywords = parseAPILMkeywords(data);
    yield put(getLMKeywordsAPISuccess(lmkeywords));
  } catch (err) {
    yield put(getLMKeywordsAPIError());
  }
}

function* postDealerLMKeywords(action: ActionPostLMKeywordsAPI) {
  try {
    const { listingId, keywordsData } = action;
    const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/keywords`, keywordsData);
    const lmkeywords: LMkeywords = parseAPILMkeywords(response.data);
    yield put(postLMKeywordsAPISuccess(lmkeywords));
  } catch (err) {
    yield put(postLMKeywordsAPIError());
  }
}

export default function* EngineKeywordSagas() {
  yield takeLatest(ACTIONS.GET_LMKEYWORDS_API_REQUEST, getDealerLMkeywords);
  yield takeLatest(ACTIONS.POST_LMKEYWORDS_API_REQUEST, postDealerLMKeywords);
}